import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-menu',
  exportAs: 'sidebarMenu',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarMenu {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-menu',
      'flex flex-col',
      'gap-y-1',

      // Nested menus
      '[&_sidebar-menu]:mt-1',
      '[&>sidebar-menu]:mt-0',

      '[&_sidebar-menu_sidebar-menu-item]:pl-6',
      '[&_sidebar-menu_sidebar-menu_sidebar-menu-item]:pl-12',
      '[&_sidebar-menu_sidebar-menu_sidebar-menu_sidebar-menu-item]:pl-18',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-menu-item',
  exportAs: 'sidebarMenuItem',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarMenuItem {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-menu-item',
      'flex w-full items-center rounded-md select-none',
      'h-9 gap-x-1.5',

      // Active and hover states
      '[&]:has-[>a:not(.active)]:hover:bg-neutral-a3',
      '[&]:has-[>button:not(.active)]:hover:bg-neutral-a3',
      'has-[>a.active]:bg-neutral-a3',
      'has-[>button.active]:bg-neutral-a3',
      'has-data-sidebar-menu-item-active:bg-neutral-a3',

      // Everything except anchors and buttons
      '*:not-[a]:not-[button]:first:ms-2',
      '*:not-[a]:not-[button]:last:me-2',

      // Anchor
      '*:[a]:flex *:[a]:cursor-pointer *:[a]:items-center *:[a]:rounded-md',
      '*:[a]:h-9 *:[a]:w-full *:[a]:min-w-0 *:[a]:gap-x-1.5',
      '*:[a]:first:ps-2',
      '*:[a]:last:pe-2',

      // Button
      '*:[button]:flex *:[button]:cursor-pointer *:[button]:items-center *:[button]:rounded-md *:[button]:text-left',
      '*:[button]:h-9 *:[button]:w-full *:[button]:min-w-0 *:[button]:gap-x-1.5',
      '*:[button]:first:ps-2',
      '*:[button]:last:pe-2',

      // User classes
      this.userClass(),
    ),
  );
}
